module.exports = __webpack_public_path__ + "static/media/change-plan.0f614fcb.svg";